import Vue from 'vue'
import BFormGroup from 'b-form-group'
import Vuemerang from 'vuemerang'
import 'vuemerang/dist/vuemerang.css'
import Unicon from 'vue-unicons/dist/vue-unicons-vue2.umd'
import { uniApps, uniShoppingCart, uniShoppingBag, uniBookOpen, uniConstructor } from 'vue-unicons/dist/icons'

Unicon.add([ uniApps, uniShoppingCart, uniShoppingBag, uniBookOpen, uniConstructor ])
Vue.use(Unicon)

Vue.use(BFormGroup)
Vue.use(Vuemerang, {
  theme: {
    colors: {
      primary: '#D06325',
      secondary: '#afbbc6',
      success: 'rgb(23, 201, 100)',
      danger: 'rgb(242, 19, 93)',
      warning: 'rgb(255, 130, 0)',
      dark: 'rgb(36, 33, 69)',
      gray: '#afbbc6'
    }
  }
})
